// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1khhJ","select":"Header_select__nh4O0","clinic":"Header_clinic__1eGJg"};